import { AxiosPromise } from "axios";
import { axiosInstance } from "../instance";
import {
  VacancyUpdateRequest,
  IExportVacancy,
  IExportVacancyFields,
  IRecruiter,
  VacancyViewRequest,
  IRecruiterByDepartmentRequest,
  IVacancy,
  VacanciesRequest,
  VacanciesResponse,
} from "./types";
import { Vacancy } from "@/model/vacancy";

const defaultVacancyExpand: Array<keyof Omit<Vacancy, "id">> = [
  "candidates",
  "customer",
  "project",
  "department",
  "application",
  "candidate_requirements",
  "candidate_grade",
  "job_duties",
  "job_format",
  "job_workload",
  "attraction_period",
  "location",
  "status",
  "candidates",
  "candidates_count",
  "sales_max_offer_regions",
  "sales_max_offer_moscow",
  "marginality",
  "salary_tk_max",
  "salary_ip_max",
  "salary_gph_max",
  "required_number",
  "attachments",
  "comments",
  "project_description",
  "office_address",
  "recruiters",
  "created_by",
  "created_at",
  "updated_at",
  "activities",
  "sales_max_offer_general",
  "legal_entity",
  "profile",
  "purchase_rate_max",
  "sales_max_offer_general",
];

export const vacancy = (data?: VacancyViewRequest): AxiosPromise<Vacancy> => {
  const { id, expand } = data?.params || {};
  return axiosInstance.get(
    `/vacancy/${id}/view?expand=${expand?.length ? expand?.join(",") : defaultVacancyExpand.join(",")}, application.sales_max_offer_general`,
    {
      params: {
        id,
        expand,
      },
    },
  );
};

export const vacancies = (data?: VacanciesRequest): AxiosPromise<VacanciesResponse> => {
  const { limit, offset, sort_column, sort_direction, ...rest } = data?.params?.filters || {};
  return axiosInstance.get(`/vacancies?expand=${data?.params?.expand?.length ? data?.params?.expand?.join(",") : defaultVacancyExpand.join(",")}`, {
    params: {
      limit,
      offset,
      sort_column,
      sort_direction,
      ...rest,
    },
  });
};

export const getRecruitersByDepartment = (params: IRecruiterByDepartmentRequest): AxiosPromise<IRecruiter[]> =>
  axiosInstance.post(`/recruiters`, params);

export const updateVacancy = (data: VacancyUpdateRequest): AxiosPromise<Vacancy> =>
  axiosInstance.post(`/vacancy/${data.params.id}/update`, data.body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const exportVacancyFields = (id: number): AxiosPromise<IExportVacancyFields> => axiosInstance.get(`/vacancy/${id}/export-fields`);

export const exportVacancy = (id: number, params: IExportVacancy): AxiosPromise<Blob> =>
  axiosInstance.post(`/vacancy/${id}/export`, params, {
    responseType: "blob",
  });
